import newEventAction from './eventsBucket';

function createTicket(data, eventSlug, boatSlug, push, callback) {
  if (push) {
    data.pushEvent = push;
  }
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'TICKET_CREATE_REQUESTED' });
    return api({
      method: 'PUT',
      url: `/ticket/`,
      params: {
        eventSlug,
        boatSlug,
      },
      data,
    }).then(
      (returnedData) => {
        const tiket = returnedData.data;
        dispatch(newEventAction.getEventPublic(eventSlug, null, true));
        dispatch({ type: 'TICKET_CREATE_SUCCESS', tiket });
        callback(null, tiket);
      },
      (error) => {
        let err = { _error: 'Server Error. Please try again later' };
        if (error.response && error.response.data) {
          err = {
            ...error.response.data.errors,
            _error: error.response.data.error,
          };
        }
        dispatch({ type: 'TICKET_REQUEST_FAILURE', errors: err });
        callback(err._error);
      },
    );
  };
}

export default {
  createTicket,
};
